import React, { Component } from 'react';
import Magnifier from 'react-magnifier';
import './404.css';

export default class NotFound extends Component {

  componentDidMount() {
    this.props.setPage("404");
  }

  render() {
    return (
      <div className="notfound">
        <h1>Error 404</h1>
        <Magnifier src="/images/404.png" zoomImgSrc="/images/404-zoom.png" zoomFactor={0.75} mgHeight={300} mgWidth={300} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/404/404.js